module.exports = __webpack_public_path__ + "media/images/contest-menu-label-23ff06b6422e55277af264d5b8ad8c21.png";